import { TableSorting } from '@src/types'
import { IbanVerification } from '@src/types/IbanVerification'
import { AxiosRequestConfig } from 'axios'
import { ApiRes, api } from './client'

export type IbanVerificationsResponse = {
    success: boolean
    iban_verifications: IbanVerification[]
    iban_verifications_count: number
}

export const getIbanVerifications = (
    contract_uid: string,
    filters?: object,
    page?: number,
    limit?: number,
    sorting?: TableSorting[]
): ApiRes<IbanVerificationsResponse> => {
    const config: AxiosRequestConfig = {}

    config.params = {}

    if (filters && Object.keys(filters).length) {
        config.params = filters
    }

    if (typeof page === 'number' && typeof limit === 'number') {
        config.params['range'] = page * limit - limit + '-' + page * limit
    }

    if (sorting && sorting.length) {
        config.params['sort'] = sorting
            .map((sort) => {
                return (sort.direction === 'desc' ? '-' : '') + sort.field
            })
            .join(',')
    }

    return api.get(
        `/manage/contracts/${contract_uid}/iban_verifications`,
        config
    )
}

export const createIbanVerification = (
    contract_uid: string
): ApiRes<{ iban_verification: IbanVerification }> => {
    return api.post(`/manage/contracts/${contract_uid}/iban_verifications`)
}
